<template>
    <div style="padding-top: 10px; height: 375px; overflow-y: scroll;">
        <div class="certbox_list">
          <dl v-for="item in lists" :key="item.id">
            <dt> <img :src="item.certPath" /> </dt>
            <dd>
              <h4>标题名称标题名称</h4>
            </dd>
          </dl>
        </div>
    </div>
</template>

<script>
    export default {
      data () {
        return {
          outputs: [],
          lists: []
        }
      },
      props: ['params'],
      mounted () {
        this.search(this.params.inputs.filters)
      },
      methods: {
        search (filters) {
          this.$api.get(this.$global.bylApiPath, '/cert/findByIdcard/' + filters.idcard, null, r => {
            if (r.data) {
              this.lists = r.data
            }
          })
        }
      }
    }
</script>

<style scoped>
  .certbox_list dl {
    width: 300px;
    height: 175px;
    box-shadow: 2px 6px 15px #e6e6e6;
    margin-left: 15px;
    float: left;
    margin-bottom: 35px;
    margin-right: 8px;
    position: relative;
  }
  .certbox_list dl dt img {
    width: 300px;
    height: 140px;
  }
  .certbox_list dl dd h4 {
    height: 40px;
    padding-left: 15px;
    font-weight: normal;
    width: 195px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/CertBox/index.vue